import React from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {procedurePageUrl} from 'procedures/network/procedureUrls';
import ProcedurePageLink from 'procedures/ProcedurePageLink';
import {
  getPowAgnosticProcedureFromFlowchartVersion,
  getPowAgnosticTemplateFlowchartVersionFromProcedureRun,
} from 'procedures/utils/powAgnosticFlowchartHelpers';

import {ProcessTaskProcedureInfoGraphQL_ProcessTaskNode_procedureRun_ProcedureRunNode_templateProcedureFlowchartVersion as TemplateProcedureFlowchartVersionGql} from '../../graphql-fragments/processes/__generated/ProcessTaskProcedureInfoGraphQL';
import {ProcessTaskProcedureInfoGraphQL_ProcessTaskNode_procedureRun_ProcedureRunNode_procedureFlowchartConfigVersionProxy as ProcedureFlowchartConfigVersionProxyOrInaccessibleInfoNodeGql} from '../../graphql-fragments/processes/__generated/ProcessTaskProcedureInfoGraphQL';

interface ProcedurePageLinkForProcedureRunProps {
  procedureRun: {
    __typename: 'ProcedureRunNode';
    templateProcedureFlowchartVersion: TemplateProcedureFlowchartVersionGql;
    procedureFlowchartConfigVersionProxy?: ProcedureFlowchartConfigVersionProxyOrInaccessibleInfoNodeGql | null;
  };
  className?: string;
}

export default function ProcedurePageLinkForProcedureRun(
  props: ProcedurePageLinkForProcedureRunProps
): JSX.Element | null {
  const flowchartVersion = getPowAgnosticTemplateFlowchartVersionFromProcedureRun(props.procedureRun);
  if (isInaccessible(flowchartVersion)) {
    return <>(No access)</>;
  }

  const parent = getPowAgnosticProcedureFromFlowchartVersion(flowchartVersion);
  return (
    <ProcedurePageLink className={props.className} href={procedurePageUrl(parent.id)}>
      {parent.name}
    </ProcedurePageLink>
  );
}
